import moment, { Moment } from 'moment';
import Vue from 'vue';

export class DateFormat {
    public static Canonical = 'YYYY-MM-DD';
    public static DefaultDisplay = 'D MMMM YYYY';
    public static ShortDisplay = 'D MMM YYYY';
    public static DayDisplay = 'dddd D MMMM YYYY';
    public static DefaultDateTimeDisplay = 'D MMM YYYY h:mma';
    public static MonthDisplay = 'MMMM YYYY';
}

Vue.filter('formatDate', (value: Moment, format?: string) => {
    if (value) {
        if (!format) {
            format = DateFormat.DefaultDisplay;
        }

        return moment(value).format(format);
    } else {
        return '';
    }
});

Vue.filter('formatDateShort', (value: Moment, format?: string) => {
    if (value) {
        if (!format) {
            format = DateFormat.ShortDisplay;
        }

        return moment(value).format(format);
    } else {
        return '';
    }
});

Vue.filter('formatDateTime', (value: Moment, format?: string) => {
    if (value) {
        if (!format) {
            format = DateFormat.DefaultDateTimeDisplay;
        }

        return moment(value).format(format);
    } else {
        return '';
    }
});
